<template>
  <div class="invalid-feedback" v-if="field.$error">
    {{ transformText }}
  </div>
</template>

<script>
export default {
  name: 'FormValidationInvalidFeedback',
  props: {
    field: { type: Object, required: true },
    text: [Object, String]
  },
  computed: {
    transformText: function () {
      if (typeof this.text === 'string') {
        return this.text
      }

      const messageKey = Object.keys(this.field).find(key => Object.keys(this.text).includes(key) && !this.field[key])
      if (!messageKey || !this.text[messageKey]) {
        return this.text
      }

      return this.text[messageKey]
    }
  }
}
</script>

<style scoped>
  .invalid-feedback {
    display: block;
  }
</style>
